// Libraries
import { Box, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { DelcoteGSStyle } from "./DelcoteGSStyle";

import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/ProductsCommonViewModel";
import { DelcoteGSViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/DelcoteProductsViewModels/DelcoteGSViewModel";
import { BQSEditNumber } from "Custom/Views/Primitives/Edits/BQSEditNumber";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";
import { BQSSelect } from "Custom/Views/Primitives/Selects/BQSSelect";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    viewModel: DelcoteGSViewModel;
}

export const DelcoteGS: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind
    const delcoteGSStyle = DelcoteGSStyle();
    const editVariants = EditVariants();
    // #endregion Code Behind

    // #region Render Result
    return useObserver(() => (
        <Box className={delcoteGSStyle.root}>
            <BQSRow className={delcoteGSStyle.selectContainer}>
                <BQSSelect
                    disableClearable={true}
                    displayName="Which topcoat colour option do you require?"
                    execute={props.viewModel.setTopcoatColour}
                    getOptionLabel={(option) => option.title}
                    groupBy={(option) => option.group}
                    options={props.viewModel.colours}
                    value={props.viewModel.topcoatColourSelection}
                    showColourLink={true}
                />
            </BQSRow>
            <BQSRow className={delcoteGSStyle.textContainer}>
                <Typography className={delcoteGSStyle.basecoatSelection}>
                    Basecoat colour option will be <b>{props.viewModel.basecoatColourSelection.title}</b>
                </Typography>
            </BQSRow>
            <BQSRow className={delcoteGSStyle.editsContainer}>
                <BQSEditNumber
                    className={editVariants.bqsEditNumberStandard}
                    displayName="Gutter length"
                    endAdornment="m"
                    execute={props.commonViewModel.setGutterLengthMeterage}
                    minimumValue={0}
                    startAdornment={`<div class="${editVariants.bqsKeyAAdornment}"></div>`}
                    value={props.viewModel.gutterLengthMeterage}
                />
                <BQSEditNumber
                    className={editVariants.bqsEditNumberStandard}
                    displayName="Gutter girth"
                    endAdornment="mm"
                    execute={props.commonViewModel.setGirth}
                    minimumValue={0}
                    startAdornment={`<div class="${editVariants.bqsKeyBAdornment}"></div>`}
                    value={props.viewModel.girth}
                />
            </BQSRow>
            <BQSRow className={delcoteGSStyle.editsContainer}>
                <BQSEditNumber
                    className={editVariants.bqsEditNumberStandard}
                    displayName="Number of joints"
                    execute={props.viewModel.setGutterJoints}
                    minimumValue={0}
                    value={props.viewModel.gutterJoints}
                />
                {/*                 <BQSEditNumber
                    className={editVariants.bqsEditNumberLarge}
                    displayName="Number of bolts per joint"
                    execute={props.viewModel.setBoltsPerJoint}
                    minimumValue={0}
                    value={props.viewModel.boltsPerJoint}
                /> */}
            </BQSRow>
        </Box>
    ));

    // #endregion Render Result
};
